export default (unitOfMeasure: string): string =>
  ["FT", "LNFT", "Linear Ft."].includes(unitOfMeasure) ? "Length" : "Quantity";
